var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map",staticStyle:{"flex":"1"}},[_c('div',{ref:"mapBox",staticStyle:{"width":"100%","min-height":"300px","height":"calc( 100vh - 80px - 48px - 30px )"}})])}
var staticRenderFns = []

export { render, staticRenderFns }